import { useTranslation } from "react-i18next";
import { AppButton } from "@/shared/Components";
import { DocumentIcon } from "@/shared/icons";
import { DEFAULT_NOTE_TYPES, type Note } from "@/services/api";
import type { FC } from "react";
import styles from "./styles.module.scss";

type Props = {
  addNoteHandler?: () => void;
  noteType: Note["noteType"]["name"];
};

const getNoteName = (type: Note["noteType"]["name"]) => {
  const { t } = useTranslation();

  switch (type) {
    case DEFAULT_NOTE_TYPES.DEFAULT_COMMITMENT:
      return t("notesPage.noNoteType.commitments");
    case DEFAULT_NOTE_TYPES.DEFAULT_IDEA:
      return t("notesPage.noNoteType.ideas");
    case DEFAULT_NOTE_TYPES.DEFAULT_NOTE:
      return t("notesPage.noNoteType.notes");
  }
};

export const NoNotePage: FC<Props> = ({ addNoteHandler, noteType }) => {
  const { t } = useTranslation();

  return (
    <div className={styles.root}>
      <DocumentIcon />
      <p className={styles.title}>
        {t("notesPage.noNotes", {
          noteType: getNoteName(noteType),
        })}
      </p>
      <AppButton className={styles.button} onClick={addNoteHandler}>
        + {t("notesPage.addNote")}
      </AppButton>
    </div>
  );
};
